import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  Filters,
  SortBy,
} from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import { TabellaDinamica } from 'src/app/components/tabella-cfg-dinamica/tabella-cfg-dinamica.component';
import { Ambito } from '../ambiti/ambiti.service';
import { AziendaService } from '../azienda/azienda.service';
import { GruppoCfgStampa } from '../config-stampe/config-stampe.service';
import { InformativaAziendale } from '../informativa-aziendale/informativa-aziendale.service';
import { QuestionarioSostenibileVsme } from '../questionari/questionari.service';
import { WebService } from '../web/web.service';
import { MotivazioneTematica } from './report-vsme.service';

@Injectable({
  providedIn: 'root',
})
export class ReportVsmeWebService {
  private readonly nomeWs = 'report-vsme';
  private _idAzienda: string | undefined = undefined;
  private readonly lang = 'it-IT';

  constructor(
    private readonly aziendaService: AziendaService,
    private readonly webService: WebService,
  ) {
    this.aziendaService.aziendaCorrente.subscribe((azienda) => {
      this._idAzienda = azienda?.id;
    });
  }
  public get(
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ): Observable<any> {
    return this.webService.doPost(
      '/api/v1/azienda/' + this._idAzienda + '/' + this.nomeWs + '/list',
      { page, pageSize, ricerca, filters, sortBy },
    );
  }

  public delete(idRiga: any): Observable<any> {
    return this.webService.doDelete(
      '/api/v1/azienda/' + this._idAzienda + '/' + this.nomeWs + '/delete',
      { id: idRiga },
    );
  }

  public archivia(idModulo: any): Observable<any> {
    return this.webService.doPut(
      '/api/v1/azienda/' + this._idAzienda + '/' + this.nomeWs + '/' + idModulo + '/archivia',
      {},
    );
  }

  public disarchivia(idModulo: any, idSettore: string): Observable<any> {
    return this.webService.doPut(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idModulo +
        '/settore/' +
        idSettore +
        '/ripristina',
      {},
    );
  }

  /* ---------------- C R E A Z I O N E   V S M E ---- step1 ------------*/

  /**
   * Creazione step 1 reportVsme
   * @param reportVsmeSostenibilita oggetto reportVsme di sostenibilita
   * @returns
   */
  public postCreazioneReportVsmeStep1(reportVsmeSostenibilita: any) {
    return this.webService.doPost(
      '/api/v1/azienda/' + this._idAzienda + '/' + this.nomeWs,
      reportVsmeSostenibilita,
    );
  }

  /**
   * Aggiornamento step 1 reportVsme
   * @param reportVsmeSostenibilita id reportVsme di sostenibilita
   * @returns
   */
  public putAggiornamentoReportVsmeStep1(
    idReportVsmeSostenibilita: any,
    fatturato: number,
    nrDipendenti: number,
  ) {
    const updReportVsme = {
      fatturato: fatturato,
      nrDipendenti: nrDipendenti,
    };

    return this.webService.doPut(
      '/api/v1/azienda/' + this._idAzienda + '/' + this.nomeWs + '/' + idReportVsmeSostenibilita,
      updReportVsme,
    );
  }

  /* ---------------- C R E A Z I O N E  S T E P  3---- step3 ------------*/
  /**
   * Compilazione
   * @param idReportVsmeSostenibilita
   * @param infoAz
   * @returns
   */
  putSalvaCompilazioneInformativa(idReportVsmeSostenibilita: string, infoAz: InformativaAziendale) {
    return this.webService.doPut(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsmeSostenibilita +
        '/informativa',
      infoAz,
    );
  }
  putSalvaCompilazioneInformativaBozza(
    idReportVsmeSostenibilita: string,
    infoAz: InformativaAziendale,
  ) {
    return this.webService.doPut(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsmeSostenibilita +
        '/informativa-bozza',
      infoAz,
    );
  }

  /**
   * get della compilazione informativa aziendale
   * @param idReportVsmeSostenibilita
   * @returns
   */
  getCompilazioneInformativa(idReportVsmeSostenibilita: string) {
    return this.webService.doGet(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsmeSostenibilita +
        '/lang/' +
        this.lang +
        '/informativa',
      {},
    );
  }

  /**
   * Tabella informativa azeidnale
   * @param idReportVsmeSostenibilita
   * @returns
   */
  getInformativa(idReportVsmeSostenibilita: string) {
    return this.webService.doGet(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsmeSostenibilita +
        '/figura',
      {},
    );
  }

  /**
   * Cambio figura
   * @param idReportVsmeSostenibilita
   * @param idFigura
   * @returns
   */
  putCambiaFiguraInformativa(idReportVsmeSostenibilita: string, idFigura: string) {
    return this.webService.doPut(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsmeSostenibilita +
        '/informativa/figura/' +
        idFigura,
    );
  }

  /**
   * inviaMail
   * @param idReportVsmeSostenibilita
   * @returns
   */
  inviaMailInformativa(idReportVsmeSostenibilita: string) {
    return this.webService.doPost(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsmeSostenibilita +
        '/lang/' +
        this.lang +
        '/informativa/invio-mail',
      {
        idReportVsmeSostenibilita,
      },
    );
  }

  /**
   * inviaNotifica
   * @param idReportVsmeSostenibilita
   * @returns
   */
  inviaNotificaInformativa(idReportVsmeSostenibilita: string) {
    return this.webService.doPost(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsmeSostenibilita +
        '/lang/' +
        this.lang +
        '/informativa/invio-notifica',
      {
        idReportVsmeSostenibilita,
      },
    );
  }

  /* ------------------------- T E M A T I C H E step 3 -------------------------------- */

  public getQuestionarioReportVsme(idReportVsmeSostenibilita: string) {
    return this.webService.doGet(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsmeSostenibilita +
        '/questionario-di-reportVsme',
      {},
    );
  }

  /**
   *
   * @returns
   */
  public putQuestionarioReportVsme(
    idReportVsmeSostenibilita: string,
    questionario: QuestionarioSostenibileVsme,
  ) {
    return this.webService.doPut(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsmeSostenibilita +
        '/questionario-di-reportVsme',
      {
        ...questionario,
      },
    );
  }

  /**
   * Salvataggio delle motivazioni per la quale la tematica non è stata tratta
   * @param idReportVsmeSostenibilita
   * @param motivazioneTematica
   * @returns
   */
  public putSalvaMotivazioneTematica(
    idReportVsmeSostenibilita: string,
    motivazioneTematica: MotivazioneTematica[],
  ) {
    return this.webService.doPut(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsmeSostenibilita +
        '/motivazione-tematica-reportVsme',
      motivazioneTematica,
    );
  }

  /**
   * ASSEGNA FIGURA A risposta VSME
   * @param idVsme
   * @param idAmbito
   * @param idTematica
   * @param chiaveRisposta
   * @param idFigura
   * @returns
   */
  public putAssegnaFiguraElementoVsme(
    idVsme: string,
    idAmbito: string,
    idTematica: string,
    chiaveRisposta: string,
    idSottoRisposta: string,
    idFigura: string,
  ) {
    return this.webService.doPut(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idVsme +
        '/ambito/' +
        idAmbito +
        '/tematica/' +
        idTematica +
        '/risposta/' +
        chiaveRisposta +
        '/sottorisposta/' +
        idSottoRisposta +
        '/figura/' +
        idFigura,
      {},
    );
  }

  public salvaCompilazione(idReportVsme: string, ambiti: Ambito[]): Observable<any> {
    return this.webService.doPut(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsme +
        '/tematiche-report-compilate',
      ambiti,
      {},
    );
  }

  /* ------------------------- C R U S C O T T O     STEP 9  -------------------------------- */
  public getTotaliCruscotto(idReportVsme: string) {
    return this.webService.doGet(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsme +
        '/totale-compilazioni',
      {},
    );
  }

  /**
   * lista cruscotti
   * @param page
   * @param pageSize
   * @param ricerca
   * @param filters
   * @param sortBy
   * @returns
   */
  public getCruscotti(
    idReportVsme: string,
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ): Observable<any> {
    return this.webService.doPost(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsme +
        '/list-elementi-per-figura',
      {
        page,
        pageSize,
        ricerca,
        filters,
        sortBy,
      },
    );
  }

  /**
   * Cambio figura
   * @param idReportVsme
   * @param idFiguraPrecedente
   * @param idFiguraNuova
   * @returns
   */
  public putCambiaFigura(idReportVsme: string, idFiguraPrecedente: string, idFiguraNuova: string) {
    return this.webService.doPut(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsme +
        '/figura/' +
        idFiguraPrecedente +
        '/cambia/' +
        idFiguraNuova,
    );
  }

  public inviaMailMultiple(idReportVsme: string) {
    return this.webService.doPost(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsme +
        '/invio-multiplo',
      {
        idReportVsme,
      },
    );
  }

  public inviaNotificaMultiple(idReportVsme: string) {
    return this.webService.doPut(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsme +
        '/notifica-multiplo',
      {
        idReportVsme,
      },
    );
  }

  public inviaMail(idReportVsme: string, idFigura: string) {
    return this.webService.doPost(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsme +
        '/figura/' +
        idFigura +
        '/invio-singolo',
      {
        idReportVsme,
        idFigura,
      },
    );
  }

  public inviaNotifica(idReportVsme: string, idFigura: string) {
    return this.webService.doPut(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsme +
        '/figura/' +
        idFigura +
        '/notifica-singolo',
      {
        idReportVsme,
        idFigura,
      },
    );
  }

  public putTemplateMail(idReportVsme: string, templateMail: any): Observable<any> {
    return this.webService.doPut(
      '/api/v1/azienda/' + this._idAzienda + '/' + this.nomeWs + '/' + idReportVsme + '/template',
      templateMail,
      { idReportVsme },
    );
  }

  public getTemplateMail(idReportVsme: string) {
    return this.webService.doGet(
      '/api/v1/azienda/' + this._idAzienda + '/' + this.nomeWs + '/' + idReportVsme + '/template',
      { idReportVsme },
    );
  }

  /**
   * Cambio stato a pubblicato del REPORT VSME
   * @param idReportVsme
   * @returns
   */
  public pubblicaReportVsme(idReportVsme: string) {
    return this.webService.doPut(
      '/api/v1/azienda/' + this._idAzienda + '/' + this.nomeWs + '/' + idReportVsme + '/pubblica',
      {},
    );
  }

  /* COMPILAZINE FIGURE */
  public getElementoDaCompilare(
    idReportVsme: string,
    idAmbito: string,
    idTematica: string,
    idElemento: string,
    chiaveRisposta: string,
  ) {
    return this.webService.doGet(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsme +
        '/questionario/ambito/' +
        idAmbito +
        '/tematica/' +
        idTematica +
        '/risposta/' +
        chiaveRisposta +
        '/elemento/' +
        idElemento,
      {
        idAzienda: this._idAzienda,
        idAmbito,
        idTematica,
        idElemento,
        idReportVsme,
      },
    );
  }

  public postElementoDaCompilare(
    idReportVsme: string,
    idAmbito: string,
    idTematica: string,
    idElemento: string,
    risposta: string | number,
    idCategoriaUnitaDiMisura?: string,
    idUnitaDiRiferimento?: string,
    chiaveRisposta?: string,
    dynamicTable?: TabellaDinamica,
    infoNonDisponibile?: {
      checked: false;
      risposta: string;
    },
    infoNonRilevante?: {
      checked: false;
      risposta: string;
    },
  ) {
    return this.webService.doPost(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsme +
        '/questionario/ambito/' +
        idAmbito +
        '/tematica/' +
        idTematica +
        '/risposta/' +
        chiaveRisposta +
        '/elemento/' +
        idElemento,
      {
        idAmbito,
        idTematica,
        idElemento,
        risposta,
        chiaveRisposta,
        idCategoriaUnitaDiMisura,
        idUnitaDiRiferimento,
        dynamicTable,
        infoNonDisponibile,
        infoNonRilevante,
      },
    );
  }

  public getElementiEsterniDaCompilare(temporaryToken: string) {
    return this.webService.doGet('/api/v1/compila-report-vsme/get', {
      temporaryToken,
    });
  }

  public postElementiEsterniDaCompilare(temporaryToken: string, objEsterna: any[]) {
    return this.webService.doPost('/api/v1/compila-report-vsme/compila', objEsterna, {
      temporaryToken,
    });
  }
  public invioTestMail(messaggio: string, email: string, idReportVsme: string) {
    return this.webService.doPost(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsme +
        '/test-invio-mail',
      {
        messaggio,
        email,
      },
    );
  }

  public getAnteprimaReportVsmeCompilato(idReportVsme: string, idAzienda: string): Observable<any> {
    return this.webService.doGet(
      '/api/v1/azienda/' +
        idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsme +
        '/anteprima-report-vsme-compilato',
      {},
    );
  }

  /* ------------------------- S T A M P A   STEP 10  -------------------------------- */

  /**
   * GET Configurazioni stampa BILANCIO (set intero, il filtro lo facciamo in frontend - raggruppare per tematica)
   * @param idReportVsme
   * @returns List<GruppoConfigRisultatiBilancioValori>
   */
  public getConfigStampa(idReportVsme: string) {
    return this.webService.doGet(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsme +
        '/cfg-stampa/list',
      {},
    );
  }

  public postSalvaElementiStampa(idReportVsme: string, cfgStampaBilancio: GruppoCfgStampa) {
    return this.webService.doPost(
      '/api/v1/azienda/' + this._idAzienda + '/' + this.nomeWs + '/' + idReportVsme + '/cfg-stampa',
      cfgStampaBilancio,
    );
  }

  public postStampaReportVsme(idReportVsme: string) {
    return this.webService.doPost(
      '/api/v1/azienda/' + this._idAzienda + '/' + this.nomeWs + '/' + idReportVsme + '/stampa',
      {},
    );
  }

  public postStampaInforamtiva(idReportVsme: string) {
    return this.webService.doPost(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsme +
        '/stampa-informativa',
      {},
    );
  }

  public getGenericPrompt(idReportVsme: string) {
    return this.webService.doGet(
      '/api/v1/azienda/' +
        this._idAzienda +
        '/' +
        this.nomeWs +
        '/' +
        idReportVsme +
        '/prompt/buildup',
      {},
    );
  }
}
